import { Box, Icon, Spinner, Tooltip } from '@dixa/lib-shared-habla';

import { useAppSelector } from 'utils/redux/useAppSelector';

import { elevioSelectors } from '../../elevio.reducer/selectors';

import { useSmartReplyResponse } from './useSmartReplyResponse';

export function SmartConversationReplyButton({
  articleBody,
}: {
  articleBody: string;
}): JSX.Element {
  const conversationId = useAppSelector(elevioSelectors.conversation.id);
  const articleId = useAppSelector(elevioSelectors.articleId);
  const {
    getSmartReplyResponse,
    response: { loading },
  } = useSmartReplyResponse({
    articleBody,
    articleId,
    conversationId,
  });

  if (loading) return <Spinner size={16} />;

  const tooltipContent = 'Smart Conversation Reply';

  return (
    <Tooltip content={tooltipContent}>
      <Box height="16px" style={{ cursor: 'pointer' }}>
        <Icon onClick={getSmartReplyResponse} name="ai" size={16} />
      </Box>
    </Tooltip>
  );
}
